<template>
  <div class="subscSuspensionError">
    <h2 class="subscSuspensionError__title">サブスクリプションが<br>停止中のため<br>ご利用いただけません</h2>
    <form-area >
      <submit-button text="サブスクリプションを再開する" @click="onButtonClick"/>
    </form-area>
  </div>
</template>

<script>
import SubmitButton from '../partials/SubmitButton'

export default {
  name: "SubscSuspensionError",
  components: {
    SubmitButton
  },
  methods: {
    onButtonClick(){
      location.href = '/subsc/rejoin'
    }
  }
}</script>

<style scoped lang="scss">
@import '../../../../sass/commons/commonVariables.scss';

.subscSuspensionError {
  padding: 35px 4px 30px;
  color: $col_base_black;
  max-width: 580px;
  margin: auto;

  &__title{
    margin-top: 0;
    font-size: 26px;
    line-height: 34px;
    text-align: center;
  }
}
.submit-button {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Subscription/SubscSuspensionError.vue